<template>
    <div class="orb-business-panel">
    <div class="border">
      <div class="header">
        <div class="header-text">
          <div class="pt-kicker">业务面板</div>
          <p class="card-title">{{ title }}</p>
        </div>
        <button class="close" @click="closeClick">&times;</button>
      </div>

      <div class="content">

        <!-- 一：智能监测 -->
        <div class="section-title">智能监测数据</div>
        <table class="table">
          <thead>
          <tr>
            <th>监测项</th>
            <th>当前值</th>
            <th>单位</th>
            <th>状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in monitorData" :key="item.name">
            <td>{{ item.name }}</td>
            <td>{{ item.value }}</td>
            <td>{{ item.unit }}</td>
            <td :class="item.status">{{ item.status }}</td>
          </tr>
          </tbody>
        </table>

        <!-- 二：智能设备 -->
        <div class="section-title">智能设备运行状态</div>
        <div class="device-grid">
          <div class="device-card" v-for="d in deviceList" :key="d.name">
            <div class="device-name">{{ d.name }}</div>
            <div class="device-status" :class="d.statusClass">
              {{ d.status }}
            </div>
            <div class="device-info">功率：{{ d.power }} kW</div>
            <div class="device-info">健康度：{{ d.health }}%</div>
          </div>
        </div>

        <!-- 三：AI 风险预警 -->
        <div class="section-title">AI 风险预警</div>
        <ul class="warn-list">
          <li v-for="w in warningList" :key="w.msg">
            <span :class="w.level">{{ w.level }}</span>
            {{ w.msg }}
          </li>
        </ul>

        <!-- 四：BIM 模块 -->
        <div class="section-title">三维 BIM 模型</div>

        <div class="bim-container">
          <!-- 左侧模型 -->
          <div class="bim-view">
            <div class="loading-text" v-if="loadingBIM">BIM 模型加载中...</div>
            <img
                v-if="!loadingBIM"
                class="bim-img"
                src="../assets/bim.png"
                alt="BIM 预览"
            />
          </div>

          <!-- 构件信息 -->
          <div class="bim-info">
            <div class="info-title">构件信息</div>

            <div class="info-item">
              <label>构件名称：</label>{{ selectedBim.name }}
            </div>
            <div class="info-item">
              <label>类别：</label>{{ selectedBim.type }}
            </div>
            <div class="info-item">
              <label>材质：</label>{{ selectedBim.material }}
            </div>
            <div class="info-item">
              <label>进度：</label>{{ selectedBim.progress }}%
            </div>
            <div class="info-item">
              <label>状态：</label>
              <span :class="selectedBim.statusClass">{{ selectedBim.status }}</span>
            </div>

            <button class="btn" @click="changeComponent">随机选中构件</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "smartConstruction",
  data() {
    return {
      title:"智能建造数据展示",
      /* 智能监测 */
      monitorData: [
        { name: "混凝土温度", value: 28.6, unit: "℃", status: "正常" },
        { name: "围堰水位", value: 3.2, unit: "m", status: "偏高" },
        { name: "坝体应力", value: 145, unit: "kPa", status: "正常" },
        { name: "浊度监测", value: 32, unit: "NTU", status: "预警" },
      ],

      /* 智能设备 */
      deviceList: [
        {
          name: "智能搅拌站",
          status: "运行正常",
          statusClass: "ok",
          power: 18.5,
          health: 96
        },
        {
          name: "自动测量机器人",
          status: "作业中",
          statusClass: "run",
          power: 1.2,
          health: 89
        },
        {
          name: "无人巡检车",
          status: "待命",
          statusClass: "standby",
          power: 0.3,
          health: 92
        }
      ],

      /* AI 风险预警 */
      warningList: [
        { level: "中度", msg: "基坑区域出现轻微位移趋势，请注意观察。" },
        { level: "轻度", msg: "今日风力达到6级，塔吊载荷需适当降低。" },
      ],

      /* BIM 模型加载模拟 */
      loadingBIM: true,

      /* 当前选中的构件 */
      selectedBim: {
        name: "钢筋梁 A-12",
        type: "梁",
        material: "HRB400钢筋",
        progress: 76,
        status: "正常",
        statusClass: "ok"
      },

      /* BIM 构件列表模拟 */
      bimComponents: [
        {
          name: "柱 B-02",
          type: "柱",
          material: "C30混凝土",
          progress: 45,
          status: "正常",
          statusClass: "ok"
        },
        {
          name: "钢筋梁 A-12",
          type: "梁",
          material: "HRB400钢筋",
          progress: 76,
          status: "正常",
          statusClass: "ok"
        },
        {
          name: "基础垫层 C-04",
          type: "基础",
          material: "碎石 + 混凝土",
          progress: 92,
          status: "预警",
          statusClass: "warn"
        }
      ]
    };
  },
  mounted() {
    // 模拟 BIM 加载时间
    setTimeout(() => {
      this.loadingBIM = false;
    }, 1500);
  },
  methods: {
    closeClick() {
      this.$emit("infoClose");
    },

    // 模拟：切换构件
    changeComponent() {
      const index = Math.floor(Math.random() * this.bimComponents.length);
      this.selectedBim = this.bimComponents[index];
    }
  }
};

// //.border {
//  position: relative;
//  width: 90%;
//  height: 85%;
//  background: linear-gradient(180deg,#012a34 0%, #001b22 100%);
//  border-radius: 12px;
//  margin-top: 20px;
//  padding: 12px;
//  box-sizing: border-box;
//  color: #e6f7fb;
//  display: flex;
//  flex-direction: column;
//}
</script>

<style scoped>



.border {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border-radius: 10px;
  margin-top: 0;
  padding: 18px;
  box-sizing: border-box;
  color: #eef7ff;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(99, 179, 237, 0.28);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.header-text {
  flex: 1;
}
.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.orb-business-panel {
  width: min(1040px, calc(100vw - 230px));
  height: calc(100vh - 150px);
  position: absolute;
  left: 50%;
  top: 112px;
  transform: translateX(-54%);
  z-index: 9998;
}


.content {
  padding: 20px;
  color: #e9faff;
  font-size: 14px;
  height: calc(100% - 60px); /* 避免撑出 .border 区域，数值可依情况微调 */
  overflow-y: auto;          /* 关键：竖向滚动条 */
}

.section-title {
  color: #fff;
  font-size: 14px;
  margin: 10px 0 6px 0;
}

/* 表格 */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
}
.table th {
  background: rgba(56, 189, 248, 0.1);
  padding: 6px;
  font-weight: 600;
  color: #b8ecff;
}
.table td {
  padding: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

/* 状态色 */
.正常 {
  color: #00ffea;
}
.偏高 {
  color: #ffe48a;
}
.预警 {
  color: #ff6f6f;
}

/* 设备卡片 */
.device-grid {
  display: flex;
  gap: 10px;
}
.device-card {
  width: 30%;
  padding: 12px;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
}
.device-name {
  font-size: 15px;
  color: #76d9ff;
  margin-bottom: 6px;
}
.device-status.ok {
  color: #00ffea;
}
.device-status.run {
  color: #c0ff84;
}
.device-status.standby {
  color: #ffe48a;
}
.device-info {
  color: rgba(255, 255, 255, 0.66);
}

/* AI 风险预警 */
.warn-list {
  list-style: none;
  padding: 0;
}
.warn-list li {
  margin: 4px 0;
}
.轻度 {
  padding: 2px 6px;
  background: rgba(255, 255, 150, 0.3);
  margin-right: 6px;
  border-radius: 4px;
  color: #fff59f;
}
.中度 {
  padding: 2px 6px;
  background: rgba(255, 100, 100, 0.3);
  margin-right: 6px;
  border-radius: 4px;
  color: #ff7a7a;
}

/* BIM 区域 */
.bim-container {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}
.bim-view {
  width: 65%;
  height: 260px;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-text {
  color: #76d9ff;
  font-size: 12px;
}
.bim-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.bim-info {
  width: 35%;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 12px;
  border-radius: 8px;
}
.info-title {
  font-size: 14px;
  margin-bottom: 6px;
  color: #fff;
}
.info-item {
  margin: 4px 0;
}
.info-item label {
  color: #76d9ff;
  margin-right: 6px;
}
.ok {
  color: #00ffea;
}
.warn {
  color: #ff6f6f;
}

/* 按钮 */
.btn {
  margin-top: 10px;
  width: 100%;
  padding: 6px;
  background: rgba(56, 189, 248, 0.12);
  border: 1px solid rgba(56, 189, 248, 0.32);
  color: #b8ecff;
  border-radius: 7px;
  cursor: pointer;
}
.btn:hover {
  background: rgba(56, 189, 248, 0.22);
}

.close {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s;
}
.close:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}
</style>
